export default __webpack_public_path__ + "63bf9fb27e89f836efeb74fed1a85b5c.png";